/** Trims a string. Null, undefined, and blank input become null. */
export function normalizeString(
  value: string | null | undefined
): string | null {
  const trimmed = value?.trim();
  return trimmed == null || trimmed === '' ? null : trimmed;
}
